module.exports = __webpack_public_path__ + "img/sap.f377b10c.png";